export enum ApplicationFormHistoryEventObject {
  APPLICATION_FORM = 'Formularz wniosku',
}
